module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proxyValue),
      expression: "proxyValue"
    }],
    staticClass: "form-inline",
    class: {
      errors: _vm.isErrors
    },
    attrs: {
      "type": "checkbox",
      "id": _vm.name,
      "name": _vm.name
    },
    domProps: {
      "checked": Array.isArray(_vm.proxyValue) ? _vm._i(_vm.proxyValue, null) > -1 : (_vm.proxyValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.proxyValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.proxyValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.proxyValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.proxyValue = $$c
        }
      }
    }
  }), _vm._v(" "), (_vm.isErrors) ? _c('ul', {
    staticClass: "error-placeholder"
  }, _vm._l((_vm.errors), function(error) {
    return _c('li', [_vm._v(_vm._s(error))])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5cd3953e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/CheckboxInput.vue
// module id = 1303
// module chunks = 2